import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function HelpDialogContent() {
  return (
    <Box sx={{ mb: "3em" }}>
      <Typography>
        You can view the portal user guide{" "}
        <a
          target="_blank"
          href={`${process.env.PUBLIC_URL}/resources/KY-CHFS-INDUSTRY-TM.pdf`}
          rel="noopener noreferrer"
        >
          here
        </a>{" "}
        and learn more about how to apply{" "}
        <a
          target="_blank"
          href="https://kymedcan.ky.gov/patients-and-caregivers/Pages/application.aspx"
          rel="noopener noreferrer"
        >
          {" "}
          here.
        </a>
      </Typography>
      <Typography>
        For up-to-date information on the Office of Medical Cannabis visit:{" "}
        <a
          target="_blank"
          href="https://kymedcan.ky.gov/Pages/index.aspx"
          rel="noopener noreferrer"
        >
          {" "}
          https://kymedcan.ky.gov/Pages/index.aspx.
        </a>
      </Typography>
      <Typography>
        If you need assistance while applying for a medical cannabis card,
        please call 833-727-2828.
      </Typography>
      <Typography>
        For policy related questions regarding your application, please contact
        the Kentucky Office of Medical Cannabis at{" "}
        <a href="mailto:kymedcan@ky.gov" target="_top">
          kymedcan@ky.gov
        </a>
      </Typography>

      <Typography>
        For technical support and payment questions, please contact Tyler
        Kentucky at{" "}
        <a href="mailto:nlssupport-ky-chfs@tylertech.com" target="_top">
          nlssupport-ky-chfs@tylertech.com
        </a>{" "}
        <>
          <span> or </span>
          <a href="tel:(502) 875-3733">(502) 875-3733</a>{" "}
        </>
        . Thank you!
      </Typography>
    </Box>
  );
}

export default HelpDialogContent;
